import Vue from 'vue';
import Loading from '@/components/general-components/Loading';

Vue.component('trac-loading', Loading);

